import { Injectable } from '@angular/core';

export enum LogLevelEnum {
  debug = 0,
  info = 1,
  warn = 2,
  error = 3
}

export type LogLevel = keyof typeof LogLevelEnum;

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  logLevel: LogLevel = 'debug';

  debug(...rest: any[]) {
    if (LogLevelEnum['debug'] >= LogLevelEnum[this.logLevel]) {
      console.log('[DEBUG]', ...rest);
    }
  }

  info(...rest: any[]) {
    if (LogLevelEnum['info'] >= LogLevelEnum[this.logLevel]) {
      console.info('[INFO]', ...rest);
    }
  }

  warn(...rest: any[]) {
    if (LogLevelEnum['warn'] >= LogLevelEnum[this.logLevel]) {
      console.warn('[WARN]', ...rest);
    }
  }

  error(...rest: any[]) {
    if (LogLevelEnum['error'] >= LogLevelEnum[this.logLevel]) {
      console.error('[ERROR]', ...rest);
    }
  }

  t(tag: string) {
    const self = this;
    return {
      debug: (...rest) => self.debug(`[${tag}]`, ...rest),
      info: (...rest) => self.info(`[${tag}]`, ...rest),
      warn: (...rest) => self.warn(`[${tag}]`, ...rest),
      error: (...rest) => self.error(`[${tag}]`, ...rest)
    };
  }
}
